import React from 'react';
import { Cloud, Code2 } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer>
      <div className="container footer-content">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', color: '#fff', fontWeight: 700, fontSize: '1.1rem' }}>
          <Code2 size={20} color="var(--accent-cyan)" />
          <span>ZENEROL DEV</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', background: 'rgba(255,255,255,0.04)', padding: '0.4rem 1rem', borderRadius: '9999px', border: '1px solid var(--border-color)', fontSize: '0.8rem', color: 'var(--text-muted)' }}>
          <Cloud size={16} color="var(--accent-blue)" />
          <span>Optimized & Ready for <strong>Cloudflare Pages Deployment</strong></span>
        </div>

        <p className="footer-copy">
          © {new Date().getFullYear()} Zenerol. Built with React, TypeScript, Clean OOP Architecture & Vanilla CSS.
        </p>
      </div>
    </footer>
  );
};
